export default __webpack_public_path__ + "static/media/megaplanet365_receipt.66dc878e.jpg";